import { render, staticRenderFns } from "./WhiteLogo.vue?vue&type=template&id=4e942784&scoped=true&"
import script from "./WhiteLogo.vue?vue&type=script&lang=js&"
export * from "./WhiteLogo.vue?vue&type=script&lang=js&"
import style0 from "./WhiteLogo.vue?vue&type=style&index=0&id=4e942784&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e942784",
  null
  
)

export default component.exports